/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  order-history-actions.ts
 *
 * Project Title :  Checkout
 *
 * Description	 : Order History Actions
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422336
 *
 * @Date	     : 26 Oct 2020
 *
 * @Version      : Version 1.0
 *
 * By            : H422336
 * On            : Nov, 5 2020
 * Description   : ASDS-4016 UI Enhancements for Phase-II
 *
 ******************************************************************************/
import Action from './Action';
import ActionConstants from '../action-constants';
import OrderHistoryDetails from 'modules/checkout/API/order-history-api';
import { logError } from '../../../../utils/console-utility';

class OrderHistoryActions extends Action {
    static getOrderHistory(soldTos) {
        return async (dispatch) => {
            dispatch(OrderHistoryActions.getOrderHistoryInitiated());
            OrderHistoryDetails.getOrderHistory(soldTos).then((response) => {
                if (response.orders) {
                    dispatch({
                        type: ActionConstants.GET_ORDER_HISTORY,
                        payload: {
                            isFetching: false,
                            isSuccess: true,
                            orders: response.orders
                        }
                    });
                } else {
                    dispatch({
                        type: ActionConstants.GET_ORDER_HISTORY,
                        payload: {
                            isFetching: false,
                            isSuccess: false,
                            orders: []
                        }
                    });
                }
            }).catch(error => {
                logError('Error fetching and parsing response', error);
                dispatch({
                    type: ActionConstants.GET_ORDER_HISTORY,
                    payload: {
                        isFetching: false,
                        isSuccess: false,
                        orders: []
                    }
                });
            });
        };
    }

    static getUserSoldToNumbers() {
        let soldTos: [];
        let addressDetails: any = [];

        return async (dispatch, getState) => {
            const isAdmin = getState().userValidationData.payload.isAdminUser;

            if (isAdmin) {
                addressDetails = getState().selectAccount.adminAddressDetails.data ? getState().selectAccount.adminAddressDetails.data.results : {};
            } else {
                addressDetails = getState().userValidationData.payload.userAddrDetails.results;
            }

            if (addressDetails.account.accounts) {
                soldTos = addressDetails.account.accounts.map((e) => {
                    if (e.sapSoldTo) {
                        return e.sapSoldTo[0].sapNumber;
                    }
                });
            }

            let soldToNumbers = soldTos.filter(function(number, i) {
                return soldTos.indexOf(number) === i;
            });

            dispatch({
                type: ActionConstants.SET_SOLD_TO_OPTIONS,
                payload: {
                    soldTos: soldToNumbers
                }
            });
        };
    }

    static getOrderHistoryWithFilters(fromDate: string, toDate: string, soldTo?: string, status?: string) {
        return async (dispatch, getState) => {
            const soldToObj = soldTo ? soldTo : getState().orderHistoryData.soldTos.join(',');
            const statusObj = status ? status : '';
            dispatch(OrderHistoryActions.getOrderHistoryInitiated());
            OrderHistoryDetails.getOrderHistoryWithFilters(soldToObj, statusObj, fromDate, toDate).then((response) => {
                if (response.orders) {
                    dispatch({
                        type: ActionConstants.GET_ORDER_HISTORY,
                        payload: {
                            isFetching: false,
                            isSuccess: true,
                            orders: response.orders
                        }
                    });
                    dispatch({
                        type: ActionConstants.PROCESSING_ORDER_REQUEST,
                        payload: {
                            isProcessingRequest: false
                        }
                    });
                } else {
                    dispatch({
                        type: ActionConstants.GET_ORDER_HISTORY,
                        payload: {
                            isFetching: false,
                            isSuccess: false,
                            orders: []
                        }
                    });
                }
            }).catch(error => {
                logError('Error fetching and parsing response', error);
                dispatch({
                    type: ActionConstants.GET_ORDER_HISTORY,
                    payload: {
                        isFetching: false,
                        isSuccess: false,
                        orders: []
                    }
                });
            });
        };
    }

    static base64ToArrayBufferForInvoicePDF(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
           var ascii = binaryString.charCodeAt(i);
           bytes[i] = ascii;
        }
        return bytes;
    }

    static downloadOrderInvoice(invoice: string, system: string) {
        return async (dispatch) => {
            dispatch(OrderHistoryActions.processingRequestInitiated());
            OrderHistoryDetails.downloadOrderInvoice(invoice, system).then((response) => {
                if (response) {
                    let data = OrderHistoryActions.base64ToArrayBufferForInvoicePDF(response);
                    let blob = new Blob([data], {type: 'application/pdf'});
                    let link = document.createElement('a');

                    link.href = window.URL.createObjectURL(blob);
                    link.download = invoice;
                    link.click();

                    dispatch({
                        type: ActionConstants.PROCESSING_ORDER_REQUEST,
                        payload: {
                            isProcessingRequest: false
                        }
                    });

                } else {
                    dispatch({
                        type: ActionConstants.PROCESSING_ORDER_REQUEST,
                        payload: {
                            isProcessingRequest: false
                        }
                    });
                    dispatch({
                        type: ActionConstants.GET_ORDER_HISTORY,
                        payload: {
                            isFetching: false,
                            isSuccess: false,
                            orders: []
                        }
                    });
                }
            }).catch(error => {
                logError('Error fetching and parsing response', error);
            });
        };
    }

    static updateFilters(filters, count) {
        return (dispatch)  => {
            dispatch({
                type: ActionConstants.UPDATE_ORDER_FILTERS,
                payload: {
                    filters: filters,
                    filtersCount: count
                }
            });
        };
    }

    private static getOrderHistoryInitiated() {
        return {
            type: ActionConstants.GET_ORDER_HISTORY,
            payload: {
                isFetching: true,
                isSuccess: false,
                orders: []
            }
        };
    }

    private static processingRequestInitiated() {
        return {
            type: ActionConstants.PROCESSING_ORDER_REQUEST,
            payload: {
                isProcessingRequest: true
            }
        };
    }
}

export default OrderHistoryActions;